import { ApolloProvider } from '@apollo/client'

import useHasuraContext from './useHasuraContext'

export default function HasuraContextWrapper({
  children,
  LoadingComponent,
}: {
  children: React.ReactNode
  LoadingComponent: () => React.ReactElement | null
}): React.ReactElement {
  const contextValue = useHasuraContext()

  if (contextValue == null) {
    return <LoadingComponent />
  }

  return <ApolloProvider client={contextValue.apollo}>{children}</ApolloProvider>
}
